@if (insurantsConfig()) {
    @let config = insurantsConfig();
    @if (config.headline) {
        <div class="grid-container">
            <div class="g-12 p-12:b md:p-16:b lg:p-24:b">
                <h3>{{ config.headline }}</h3>
                <hr />
            </div>
        </div>
    }
    @if (config.description) {
        <div class="grid-container">
            <div
                class="g-12"
                [innerHTML]="config.description"
            ></div>
        </div>
    }
    @for (insurant of insurants(); let $i = $index; track insurant) {
        <app-form-toggle
            [ngClass]="{ 'm-24:t md:m-32:t lg:m-48:t': $i !== 0 || config.description }"
            [multiplesAllowed]="config.maxCount > 1"
            [forceGroupedLayout]="forceGroupedLayout()"
            [title]="config.displayName"
            [formGroup]="insurant"
            [objectIndex]="$i"
            [objectsTotal]="insurants().length"
            [allowRemovingSingleItem]="config.firstOneRemovable"
            (remove)="btnRemove($i)"
        >
            <app-insurant-dynamic-form
                [formGroup]="insurant"
                [insurantsConfig]="config"
                [insuranceRanks]="insuranceRanks()"
            ></app-insurant-dynamic-form>
        </app-form-toggle>
    }
    <!-- #region note -->
    @if (!hideNote && config.note) {
        <div class="grid-container">
            <div
                class="g-12"
                [innerHTML]="config.note"
            ></div>
        </div>
    }
    <!-- #region -->
    <!-- #region add button -->
    @if (insurants().length < config.maxCount) {
        <div class="grid-container -spread-content -center-v m-48:v">
            @if (insurants().length > 0) {
                <h4 class="g-12 sm:g-6 strong">
                    {{ config.addAnotherItemText }}
                </h4>
            }
            <div class="g-auto m-12:t sm:m-0:t bg:grey-5">
                <button
                    type="button"
                    class="button -ghost -dark -add fs:xs"
                    (click)="btnAdd()"
                >
                    {{ config.addButtonLabel || 'hinzufügen' }}
                </button>
            </div>
        </div>
    }
    <!-- #endregion -->
}
